import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { AppMemoryService } from './core/app-memory.service';
import { DatePipe } from '@angular/common';
import { GetService } from 'app/core/get.service';
import { NotificationsService } from 'angular2-notifications';
import { SocetService } from './PushServices/socet.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { moment } from 'ngx-bootstrap/chronos/test/chain';

declare var $: any;

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent implements OnInit, OnDestroy {
  public user: any;
  public user_notifications: any;
  public userSub: any;
  public sub: any;
  public showTutorial = false;
  public pdfSrc = '';

  public options = {
    position: ['bottom', 'right'],
    timeOut: 5000,
    lastOnBottom: true,
    showProgressBar: false,
  };

  public translation = {};

  public serverError = null;
  public isRequestInProgress = false;
  public reportDate = {
    from: '' as string,
    to: '' as string,
    switcher: false as boolean
  };

  public dateRangeErrorMessage: { from?: string, due?: string, date?: string } = {} as { from?: string, due?: string, date?: string };

  public objectToArray(obj: Object) {
    return Object.keys(obj).map(key => obj[key]); // transorm Array-like Object to Array
  }

  public datePicker3 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 10)),
    maxDate: new Date() as Date,
    currentDate: new Date() as Date,
    currentDate_input: ''/*this.datePipe.transform(new Date(), environment.dateFormat)*/,
    isActive: false as boolean,
  };

  public datePicker4 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 10)),
    maxDate: new Date() as Date,
    currentDate: new Date() as Date,
    currentDate_input: ''/*this.datePipe.transform(new Date(), environment.dateFormat)*/,
    isActive: false as boolean,
  };

  public displayVaccinationTutorial = environment.country !== 'sa';

  constructor(public appMemory: AppMemoryService,
    public socetService: SocetService,
    public router: Router,
    private notificationsService: NotificationsService,
    public getService: GetService,
    public datePipe: DatePipe,
    private translate: TranslateService) {
    this.showTutorial = this.getService.getShowTutorial();
    this.router.events.subscribe(params => {
      if (params instanceof NavigationEnd) {
        this.appMemory.pageInfo.isHorse = false;

        let routeUrl: any = params.urlAfterRedirects.match('^/.*?[?]');
        if (routeUrl) {
          routeUrl = routeUrl[0].slice(0, -1);
        } else {
          routeUrl = params.urlAfterRedirects;
        }

        switch (routeUrl) {
          case '/profile':
            this.appMemory.pageInfo.title = 'Profile';
            break;
          case '/horses':
            this.appMemory.pageInfo.title = 'Horses';
            break;
          case '/cat':
            this.appMemory.pageInfo.title = 'Vets & Assiatants';
            break;
          case '/all-treatments':
            this.appMemory.pageInfo.title = 'Treatments';
            break;
          case '/yards':
            this.appMemory.pageInfo.title = 'Yards';
            break;
          case '/rules':
          case '/rules-book':
            this.appMemory.pageInfo.title = 'Rule Book';
            break;
          case '/about':
            this.appMemory.pageInfo.title = 'About';
            break;
          case '/contact':
            this.appMemory.pageInfo.title = 'Contact us';
            break;
          case '/admin-report':
            this.appMemory.pageInfo.title = 'Reports';
            break;
          case '/invoices':
            this.appMemory.pageInfo.title = 'Invoices';
            break;
          case '/info':
            this.appMemory.pageInfo.title = 'Account Informations';
            break;
        }
      }
    });

    this.subUserPush();
    this.socetService.createConnection.subscribe(res => {
      if (res) {
        this.subUserPush();
      }
    });
    // this.setMinDatePicker();
    this.setUpLanguage();
    this.getTranslation();
  }

  getTranslation() {
    this.translate.get('TREATS.sendReport').subscribe((word: string) => {
      this.translation['sendReport'] = word;
    });
    this.translate.get('OTHER.sentSuccess').subscribe((word: string) => {
      this.translation['sentSuccess'] = word;
    });
    this.translate.get('TREATS.report').subscribe((word: string) => {
      this.translation['report'] = word;
    });
  }

  showTutorialService() {
    return this.getService.getShowTutorial();
  }

  showOverage() {
    if (this.appMemory.user && this.appMemory.user.overage_notification) {
      this.user = this.appMemory.user;
      return true;
    }
    return false;
  }

  showUserNotification() {
    if (this.appMemory.user && this.appMemory.user.user_notification && this.appMemory.user.user_notification.length) {
      this.user_notifications = this.appMemory.user.user_notification;
      return true;
    }
    return false;
  }

  setUpLanguage() {
    this.translate.addLangs(environment.languages);
    let userLang = localStorage.getItem('equineLang') || 'en';
    if (userLang === "sa") {
      document.documentElement.lang = 'ar';
      this.translate.setDefaultLang(userLang);
    }
    else {
      document.documentElement.lang = userLang;
      this.translate.setDefaultLang(userLang);
    }
    if (this.appMemory.authService.isLoggedIn) {
      this.getService.getUser().then(user => {
        userLang = user.language || localStorage.getItem('equineLang');
        this.translate.use(userLang && userLang.match(/en|en-US|fr|sa/) ? userLang : (environment.defaultLanguage || 'en'));
        localStorage.setItem('equineLang', userLang);
      });
    } else {
      this.translate.use(userLang && userLang.match(/en|en-US|fr|sa/) ? userLang : (environment.defaultLanguage || 'en'));
    }
  }

  ngOnInit() {
    this.appMemory.year = new Date().getFullYear();
    //this.pdfSrc = environment.ruleBookBCPdPopup;
    this.pdfSrc = environment.ruleBookSC24Pdf;
  }

  ngOnDestroy() {
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  setMinDatePicker() {
    if (this.appMemory.user) {
      this.datePicker4.minDate = this.datePicker3.minDate = new Date(this.appMemory.user.created_at);
    }
  }

  changeSwitcher(val) {
    this.reportDate.switcher = val;
    this.datePicker4.minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 10));
    this.datePicker3.maxDate = new Date() as Date;
    this.datePicker4.currentDate = new Date() as Date;
    this.datePicker3.currentDate = new Date() as Date;
  }

  subUserPush() {
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
    if (this.sub) {
      this.sub.unsubscribe();
    }

    this.userSub = this.appMemory.userSubject.subscribe(() => {
      if (this.sub) {
        this.sub.unsubscribe();
      }

      if (this.appMemory.user) {
        this.sub = this.socetService.UserPush().subscribe((data: any) => {
          if (!data.data) {
            data.data = {};
          }
          data.data.created_at = new Date();
          this.appMemory.addNewPush(data);
        });
      } else {
        if (this.sub) {
          this.sub.unsubscribe();
        }
      }
    });
  }

  public sendReport() {
    this.serverError = null;

    if (new Date(this.reportDate.from) > new Date(this.reportDate.to)) {
      this.serverError = ['Incorrect dates range.'];
      return;
    }

    const body = {
      start: this.reportDate.from,
      end: !this.reportDate.switcher ? this.reportDate.to : this.reportDate.from,
    };

    this.isRequestInProgress = true;
    this.getService.sendReport(body).then(
      (res: any) => {
        this.isRequestInProgress = false;
        this.hideModal();
        this.notificationsService.success(
          `${this.translation['sendReport']}`,
          `${this.translation['report']} ${this.translation['sentSuccess']}`
        );
      },
      (err: any) => {
        if (err.status === 500) {
          this.serverError = ['Server error. Please try later.'];
        } else {
          this.serverError = this.objectToArray(JSON.parse(err._body));
        }
        this.isRequestInProgress = false;
      }
    );
  }

  hideModal(noclear?: boolean) {
    $('.modal.open').removeClass('open');
    $('body').removeClass('modal-open');

    this.reportDate = {
      to: '',
      from: '',
      switcher: false
    };
  }

  public datePickerMask = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  };

  formatDate(date) {
    if (date) {
      const arr = date.split('/');
      switch (environment.dateFormat) {
        case 'MM/dd/yyyy':
          return arr[0] + '/' + arr[1] + '/' + arr[2];
        case 'dd/MM/yyyy':
        default:
          return arr[1] + '/' + arr[0] + '/' + arr[2];
      }
    }
  }

  setFromDateInput() {
    if (this.serverError) {
      this.serverError.from = null;
    }
    this.dateRangeErrorMessage = {};
    // (new Date(this.formatDate(this.datePicker3.currentDate_input))).getTime() > this.datePicker3.maxDate.getTime() ||
    // (new Date(this.formatDate(this.datePicker3.currentDate_input))).getTime() < this.datePicker3.minDate.getTime() ||
    if (
      (new Date(this.formatDate(this.datePicker3.currentDate_input))).toDateString() === 'Invalid Date'
    ) {
      this.reportDate.from = null;
      if (this.serverError) {
        this.serverError.from = 'CORE.invalidDate';
      } else {
        this.serverError = { from: 'CORE.invalidDate' };
      }
      return;
    }
    this.datePicker3.currentDate = new Date(this.formatDate(this.datePicker3.currentDate_input));
    this.reportDate.from = this.datePipe.transform(this.formatDate(this.datePicker3.currentDate_input), 'yyyy-MM-dd');
    this.datePicker3.isActive = false;
  }

  setToDateInput() {
    if (this.serverError) {
      this.serverError.to = null;
    }
    this.dateRangeErrorMessage = {};

    // (new Date(this.formatDate(this.datePicker4.currentDate_input))).getTime() > this.datePicker4.maxDate.getTime() ||
    // (new Date(this.formatDate(this.datePicker4.currentDate_input))).getTime() < this.datePicker4.minDate.getTime() ||
    if (
      (new Date(this.formatDate(this.datePicker4.currentDate_input))).toDateString() === 'Invalid Date'
    ) {
      this.reportDate.to = null;
      if (this.serverError) {
        this.serverError.to = 'CORE.invalidDate';
      } else {
        this.serverError = { to: 'CORE.invalidDate' };
      }
      return;
    }
    this.datePicker4.currentDate = new Date(this.formatDate(this.datePicker4.currentDate_input));
    this.reportDate.to = this.datePipe.transform(this.formatDate(this.datePicker4.currentDate_input), 'yyyy-MM-dd');
    this.datePicker4.isActive = false;
  }

  setDate(date: Date, type: number) {
    this.dateRangeErrorMessage = {};
    switch (type) {
      case 1: {
        if (this.serverError) {
          this.serverError.from = null;
        }
        this.datePicker3.currentDate_input = this.datePipe.transform(date, environment.dateFormat);
        this.reportDate.from = this.datePipe.transform(date, 'yyyy-MM-dd');
        this.datePicker3.currentDate = date;
        this.datePicker4.minDate = date;
      }
        break;

      case 2: {
        if (this.serverError) {
          this.serverError.to = null;
        }
        this.datePicker4.currentDate_input = this.datePipe.transform(date, environment.dateFormat);
        this.reportDate.to = this.datePipe.transform(date, 'yyyy-MM-dd');
        this.datePicker4.currentDate = date;
        this.datePicker3.maxDate = date;
      }
        break;
    }
  }

  /**
   * Check validity of period and disabled "Pick date" button
   * @returns {boolean}
   */
  checkreportDateValidity(): void {
    if (this.reportDate.from && this.reportDate.to && this.reportDate.from >= this.reportDate.to) {
      this.dateRangeErrorMessage = {
        from: 'OTHER.fromDateGraterToDate',
        due: 'OTHER.fromDateGraterToDate'
      };
    } else if (new Date(this.reportDate.from).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
      this.dateRangeErrorMessage = {
        from: `OTHER.dateExceededReg`,
        date: moment(this.appMemory.user.created_at).format(environment.dateFormat.toUpperCase())
      };
    } else if (new Date(this.reportDate.to).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
      this.dateRangeErrorMessage = {
        due: `OTHER.dateExceededReg`,
        date: moment(this.appMemory.user.created_at).format(environment.dateFormat.toUpperCase())
      };
    } else {
      this.dateRangeErrorMessage = {};
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/app.component.ts